import {actions} from '@/store/modules/authorization/actions';
import {mutations} from '@/store/modules/authorization/mutations';
import {getters} from '@/store/modules/authorization/getters';
import {Module} from 'vuex';
import {RootState} from '@/store';

export interface AuthorizationState {
  accessToken: string | null;
  refreshToken: string | null;
  refreshingToken: boolean;
  temporaryAccessToken: string | null;
  temporaryRefreshToken: string | null;
}

export const initialState = (): AuthorizationState => {
  return {
    accessToken: '',
    refreshToken: '',
    refreshingToken: false,
    temporaryAccessToken: '',
    temporaryRefreshToken: ''
  };
};

export const authorization: Module<AuthorizationState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
